<template>
  <div class="col-lg-8 offset-lg-2 page">
    <div class="row">
      <providers-filter :arrayToFilter="allProviders" :type="type"
                        v-on:update-keywords="updateKeywords"
                        v-on:filter-providers="updateFilterResults">
      </providers-filter>
      <providers-sort></providers-sort>
    </div>

    <providers-detail :keywords="keywords"
                      :taxonomies="filteredProviders ? filteredProviders : allProviders">
    </providers-detail>

  </div>
</template>

<script>
  import { getAllProviders } from '@/data/getters.js';
  import {mapGetters} from 'vuex';
  import ProvidersDetail from './ProvidersDetail';
  import FilterPage from '../_partials/filter/FilterPage';
  import SortPage from '../_partials/sort/SortPage';

  export default {
    name: "ProvidersPage",
    components: {
      'providers-filter': FilterPage,
      'providers-sort': SortPage,
      'providers-detail': ProvidersDetail,
    },
    data() {
      return {
        filteredProviders: null,
        keywords: [],
        type: 'PROVIDERS',
      }
    },
    computed: {
      ...mapGetters('login', {
        allData: 'getAllData',
      }),
      allProviders: function () {
        return getAllProviders(this.allData);
      }
    },
    methods: {
      updateFilterResults(data) {
        this.filteredProviders = data;
      },
      updateKeywords(data) {
        this.keywords = data;
      },
    }
  }
</script>

<style scoped lang="scss">
  .page {
    max-width: 800px;
  }
</style>
